<div class="wrapper">
  <button nz-button nzType="primary"
    [ngClass]="appSignalDataService.isCollapsedMenuAside$() ? 'isCollapsedMenuAsideStart' : 'isCollapsedMenuAside'"
    (click)="toggleCollapsed()">
    <i nz-icon [nzType]="appSignalDataService.isCollapsedMenuAside$() ? 'menu-unfold' : 'menu-fold'"></i>
  </button>


  <ul nz-menu nzMode="inline" nzTheme="light" [nzInlineCollapsed]="appSignalDataService.isCollapsedMenuAside$()">
    <li nz-menu-item nz-tooltip nzTooltipPlacement="right"
      [nzTooltipTitle]="appSignalDataService.isCollapsedMenuAside$() ? 'Página Inicial' : ''" nzSelected
      (click)="isHome()">
      <div class="d-flex justify-content-start align-items-center">
        <i class="fi fi-rr-home fs-5 pe-3"></i>
        <span>Página Inicial</span>
      </div>
    </li>
    <ng-container *ngFor="let menu of menuList">
      <!-- <li nz-submenu [nzTitle]="menuTitle" nzOpen class="py-0 my-0"> -->
        <li *ngIf="hasPermissionForMenu(menu)" nz-submenu [nzTitle]="menuTitle" nzOpen class="py-0 my-0">


        <ul *ngFor="let sub of menu.subMenu">

          @if(sub.subMenuSecond) {
          <!-- <li nz-submenu [nzTitle]="menuSubTitle" class="py-0 my-0"> -->
            <li *ngIf="hasPermissionForSubMenu(sub)" nz-submenu [nzTitle]="menuSubTitle" nzOpen class="py-0 my-0">

            <ul *ngFor="let sec of sub.subMenuSecond">
              <li nz-menu-item class="subMenu">
                <div class="w-100 d-flex align-items-center justify-content-between">
                  <div>
                    <span class="fw-semibold pe-1">{{ sec.title }}</span>
                    <span class="fw-semibold">{{ sec.titleAdditional }}</span>
                  </div>
                  <!-- @if(sec.qtdNotificacoes) {
                  <nz-badge nzStandalone [nzCount]="sec.qtdNotificacoes"
                    [nzStyle]="{ backgroundColor: '#6f30a0', padding: '0px 12px', fontWeigth: 'bold' }" />
                  } -->
                </div>
              </li>
            </ul>
            <ng-template #menuSubTitle class="subMenuSecond">
              <div class="w-100 d-flex align-items-center justify-content-between pe-5">
                <div class="d-flex justify-content-start align-items-center">
                  @if(sub.titleVb) {
                  <span class="fw-semibold SCD-font">Fenacp </span>
                  }
                  <span class="fw-semibold">{{ sub.title }}</span>
                </div>
                <!-- @if(sub.qtdNotificacoes) {
                <nz-badge nzStandalone [nzCount]="sub.qtdNotificacoes"
                  [nzStyle]="{ backgroundColor: '#6f30a0', padding: '0px 12px', fontWeigth: 'bold' }" />
                } -->
              </div>
            </ng-template>
          </li>
          }
          @else {
          <li *ngIf="hasPermissionForSubMenu(sub)" nz-menu-item class="subMenu" (click)="onMenuItemClick(sub, menu.title, menu.titleVb)">
            <div class="w-100 d-flex align-items-center justify-content-between pe-3">
              <div>
                <span class="fw-semibold pe-1">{{ sub.title }}</span>
                <span class="fw-semibold">{{ sub.titleAdditional }}</span>
              </div>
              <!-- @if(sub.qtdNotificacoes) {
              <nz-badge nzStandalone [nzCount]="sub.qtdNotificacoes"
                [nzStyle]="{ backgroundColor: '#6f30a0', padding: '0px 12px', fontWeigth: 'bold' }" />
              } -->
            </div>
          </li>
          }
        </ul>
        <ng-template #menuTitle class="menu">
          <div class="w-100 d-flex align-items-center justify-content-between pe-5">
            <div class="d-flex justify-content-start align-items-center">
              @if(menu.icon) {
              <i class="fi fs-5 pe-3 pt-1" [ngClass]="menu.icon"></i>
              }
              @if(menu.titleVb) {
              <span class="fw-semibold SCD-font"></span>
              }
              <span class="fw-bold">{{ menu.title }}</span>
            </div>
            <!-- @if(menu.qtdNotificacoes) {
            <nz-badge nzStandalone [nzCount]="menu.qtdNotificacoes"
              [nzStyle]="{ backgroundColor: '#6f30a0', padding: '0px 12px', fontWeigth: 'bold' }" />
            } -->
          </div>
        </ng-template>
      </li>
    </ng-container>
  </ul>


</div>
